import { __ } from '@wordpress/i18n';

/**
 * CourseListItem Component
 * @param {Object} props
 * @returns {JSX.Element}
 */
export default function CourseRowItemMealPackage({ id, title, price }) {
	const convertPrice = (price) => {
		const formatter = new Intl.NumberFormat('fi-FI', {
			style: 'currency',
			currency: 'EUR',
		});

		return formatter.format(price);
	};

	return `+ ${convertPrice(price)} / person`;
}
